export enum UwSummarySection {
  UnderwritingInformation = 'UnderwritingInformation',
  PropertyConstruction = 'PropertyConstruction',
  BorrowerCreditInfo = 'BorrowerCreditInfo',
  BorrowerInterestSource = 'BorrowerInterestSource',
}

export type IUwSummaryConfig = Record<UwSummarySection, Record<string, { visible?: boolean; required?: boolean }>>

export const UwSummarySectionText: Record<UwSummarySection, string> = {
  [UwSummarySection.UnderwritingInformation]: 'Underwriting Information',
  [UwSummarySection.PropertyConstruction]: 'Property/Construction',
  [UwSummarySection.BorrowerCreditInfo]: 'Borrower Credit/Info',
  [UwSummarySection.BorrowerInterestSource]: 'Source of Borrowers Interest In Subject Property',
}

export const inputGroups: Record<UwSummarySection, string[]> = {
  [UwSummarySection.UnderwritingInformation]: [
    'InvestorCode',
    'OriginationChannel',
    'DocumentType',
    'DocumentName',
    'Borrower_Reserves',
    'PropertyClass',
    'ProjectName',
    'SellerCredit',
    'EarnestMoneyAmount',
    'PROJ250_AccrualType',
    'MedianHomePrice',
    'AIV2MedianRate',
    'ARV2MedianRate',
    'Mers',
    'InterestType',
    'ExceptionTitle',
    'PROJ250DealNarrative',
    'constructionCompanyAddressMap',
  ],
  [UwSummarySection.PropertyConstruction]: [
    'PROJ250_Construction',
    'PROJ250_IsNewConstruction',
    'PROJ250_NewAcquisition',
    'PROJ250_PropertyYouAlreadyOwn',
    'PROJ250_PropertyAcquisitionDate',
    'PROJ250_ConstructionCompletionDate',
    'Company',
    'FullName',
    'FullAddress',
    'ContractDate',
    'CurrentSQFT',
    'AfterRehadSQFT',
    'BedroomCount',
    'BathroomCount',
    'LotSize',
    'YearBuilt',
    'purchaseDate',
    'purchasePrice',
    'numberOfUnits',
    'asIsPerUnit',
    'arvPerUnit',
    'msa',
    'numberOfProperties',
    'experience',
    'Strategy',
    'RentSource',
    'RentFromLease',
    'RentFromMarketSurvey',
    'AsIsValue',
    'AsIsAppraisedValue',
    'AfterRepairValue',
    'AfterRepairAppraisedValue',
    'MarketRent',
    'MonthlyRent',
  ],
  [UwSummarySection.BorrowerCreditInfo]: [
    'NonQMHouseholdSize',
    'BorrowerLifetimeProjects',
    'BorrowerExperiencewithOriginator',
  ],
  [UwSummarySection.BorrowerInterestSource]: [
    'BorrowersInterestSourceTypeInSubjectProperty',
    'BorrowersInterestSourceTitleInSubjectProperty',
    'RecordingInfo',
    'BorrowersInterestSourceDateInSubjectProperty',
  ],
}
